	// vendor
	import { defineComponent, ref, PropType, set, computed } from "@vue/composition-api";
	// project
	import { Dictionary } from "@/utils/types";

	type DragTransformFn = (item:any) => any;
	type ItemStringFn = (item:any) => string;

	export const IconCardGrid = defineComponent({
		props:{
			items:{
				type:Array as PropType<any[]>,
				default: () => []
			},
			idField:{
				type:String
			},
			icon:{
				type:String,
				default:"mdi.pirate"
			},
			iconColor:{
				type:String,
				default:"white"
			},
			iconClass:{
				type:String,
				default:""
			},
			showAdd:{
				type:Boolean,
				default:false
			},
			dragTransformFn:{
				type:Function as PropType<DragTransformFn>,
				default:() => null
			},
			iconFn:{
				type:Function as PropType<ItemStringFn>,
				default:null
			},
			iconColorFn:{
				type:Function as PropType<ItemStringFn>,
				default:null
			},
			dragEnabled:{
				type:Boolean,
				default:true
			}
		},
		setup(props){

			const draggedIndex = ref(-1);
			const hoverState = ref<Dictionary<boolean>>({});

			const addColor = computed(() => {
				return props.iconColor;
			});

			const getItemIcon = (item:any) => {
				return props.iconFn ? props.iconFn(item) : props.icon;
			};
			
			const getItemKey = (index:number) => {
				if(!props.idField){ return index.toString(); }
				return props.items[index][props.idField];
			};

			const setHover = (key:string, state:boolean) => {
				set(hoverState.value, key, state);
			};

			const getHover = (key:string) => {
				return hoverState.value[key];
			};

			const onDragStart = (e:any, index:number) => {
				if(!props.dragEnabled){ return; }
				draggedIndex.value = index;
				const data = props.dragTransformFn(props.items[index]);
				e.dataTransfer.setData("tagTarget", data ? JSON.stringify(data) : null);
			};

			const getItemColor = (item:any) => {
				if(props.iconColorFn){
					return props.iconColorFn(item);
				}
				return props.iconColor;
			};

			const dragEnd = () => {
				draggedIndex.value = -1;
			};

			return {
				draggedIndex,
				addColor,
				setHover,
				getHover,
				onDragStart,
				dragEnd,
				getItemKey,
				getItemColor,
				getItemIcon,
			};

		}
	})